"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductMenuDetailDualListItem = instanceOfProductMenuDetailDualListItem;
exports.ProductMenuDetailDualListItemFromJSON = ProductMenuDetailDualListItemFromJSON;
exports.ProductMenuDetailDualListItemFromJSONTyped = ProductMenuDetailDualListItemFromJSONTyped;
exports.ProductMenuDetailDualListItemToJSON = ProductMenuDetailDualListItemToJSON;
exports.ProductMenuDetailDualListItemToJSONTyped = ProductMenuDetailDualListItemToJSONTyped;
/**
 * Check if a given object implements the ProductMenuDetailDualListItem interface.
 */
function instanceOfProductMenuDetailDualListItem(value) {
    return true;
}
function ProductMenuDetailDualListItemFromJSON(json) {
    return ProductMenuDetailDualListItemFromJSONTyped(json, false);
}
function ProductMenuDetailDualListItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'menuNo': json['menuNo'] == null ? undefined : json['menuNo'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'vender': json['vender'] == null ? undefined : json['vender'],
        'series': json['series'] == null ? undefined : json['series'],
    };
}
function ProductMenuDetailDualListItemToJSON(json) {
    return ProductMenuDetailDualListItemToJSONTyped(json, false);
}
function ProductMenuDetailDualListItemToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'menuNo': value['menuNo'],
        'id': value['id'],
        'name': value['name'],
        'vender': value['vender'],
        'series': value['series'],
    };
}
